import PropTypes from "prop-types";

const NavDrawer = ({ children, isOpen }) => {
  return (
    <div
      className={`w-full bg-offWhite transition-all transition-200 overflow-hidden ${
        isOpen ? "max-h-screen" : "max-h-0"
      }`}>
      <div className="flex flex-col p-4 pb-0 space-y-2">{children}</div>
    </div>
  );
};

NavDrawer.propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default NavDrawer;
